import MDBox from "components/MDBox";
import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DataTable from "examples/Tables/DataTable";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import { getContacts } from "network/service";
import MDInput from "components/MDInput";
import { Stack } from "@mui/material";

let contactsTableHeader = [
    { Header: "Name", accessor: "name" },
    { Header: "Address", accessor: "address" },
    { Header: "Mobile", accessor: "mobile" },
    { Header: "Select", accessor: "select" }
];

export default function ContactsTable(props) {

    const [data, setData] = useState([]);

    const [searchText, setSearchText] = useState('');
    const [timeoutId, setTimeoutId] = useState(null);
    const [loading, setLoading] = useState(false);


    const handleInputChange = (event) => {
        clearTimeout(timeoutId);

        const inputText = event.target.value;
        setSearchText(inputText);

        const newTimeoutId = setTimeout(() => {
            // Call your API with the entered input
            setLoading(true);
            console.log('Calling API with input:', inputText);
            getContacts(`_search=${inputText}`).then((resp) => {
                console.log(resp.data);
                setData(resp.data);
                setLoading(false);
            }).catch((err) => {
                console.log(err);
                setLoading(false);
            })
        }, 1000);

        setTimeoutId(newTimeoutId);
    };

    const formRows = (data) => {
        let result;
        result = [];
        for (const ele of data) {
            const temp = {
                name: ele.name,
                address: ele.address,
                mobile: ele.phone,
                select: (
                    <MDBox color="text" px={2}>
                        <Button variant="contained" color="success" onClick={() => {
                            props.selectSender(ele);
                        }}>
                            Select
                        </Button>
                    </MDBox>
                ),
            };
            result.push(temp);
        }
        return result
    }

    useEffect(() => {
        setLoading(true);
        getContacts(`_limit=10`).then((resp) => {
            console.log(resp.data);
            setData(resp.data);
            setLoading(false);
        }).catch((err) => {
            console.log(err);
            setLoading(false);
        })
    }, [setData, setLoading])

    // useEffect(() => {
    //     let result;
    //     result = [];
    //     for (const ele of props.details) {
    //         const temp = {
    //             name: ele.name,
    //             address: ele.address,
    //             mobile: ele.phone,
    //             select: (
    //                 <MDBox color="text" px={2}>
    //                     <Button variant="contained" color="success" onClick={() => {
    //                         props.selectSender(ele);
    //                     }}>
    //                         Select
    //                     </Button>
    //                     {/* <Button variant="outlined" onClick={() => {
    //                         props.selectSender(ele);
    //                     }}>Outlined</Button> */}
    //                     {/* <EditIcon sx={{ fontWeight: "bold" }} fontSize="small"
    //                          /> */}
    //                 </MDBox>
    //             ),
    //         };
    //         result.push(temp);
    //     }
    //     setData(result)
    // }, [setData]);

    return (
        <Dialog
            id="modal-display"
            open={props.isopen}
            aria-labelledby="contacts-list"
            aria-describedby="modal-modal-description"
            maxWidth="90%"
            onClose={props.handleclose}
        >
            <DialogContent style={{ width: 1500, height: 'auto' }}>
                <Stack
                    direction="row-reverse"
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={2}
                >
                    <MDInput label="Search" disabled={loading} onChange={handleInputChange} />
                </Stack>

                <DataTable
                    table={{ columns: contactsTableHeader, rows: formRows(data) }}
                    // canSearch
                    // entriesPerPage={false}
                    isSorted={false}
                    // showTotalEntries={false}
                    noEndBorder
                />
            </DialogContent>
        </Dialog>
    );
}